document.documentElement.classList.remove('no-js');

(function () {
  'use strict';

  /* ═══════════════════════════════════════════
     iOS-safe body scroll lock
     position:fixed + stored offset is the only
     reliable method on iOS Safari.
     ═══════════════════════════════════════════ */
  var _scrollY = 0;

  function lockScroll() {
    if (document.body.dataset.scrollLocked === 'true') return;
    _scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.dataset.scrollLocked = 'true';
  }

  function unlockScroll() {
    if (document.body.dataset.scrollLocked !== 'true') return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.removeAttribute('data-scroll-locked');
    window.scrollTo(0, _scrollY);
  }


  /* ═══════════════════════════════════════════
     Drawer (full-screen menu)
     ═══════════════════════════════════════════ */
  function getDrawer() {
    return document.querySelector('[data-menu-drawer]');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer || drawer.classList.contains('is-open')) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();

    var close = drawer.querySelector('[data-menu-close]');
    if (close) setTimeout(function () { close.focus(); }, 50);
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }


  /* ═══════════════════════════════════════════
     Accordion groups inside drawer
     ═══════════════════════════════════════════ */
  function initAccordion() {
    var toggles = document.querySelectorAll('[data-menu-group-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-menu-group]');
        if (!group) return;

        var panel = group.querySelector('[data-menu-group-panel]');
        var isOpen = group.classList.contains('is-open');

        // Close others in the same drawer (single-open behavior)
        var drawer = group.closest('[data-menu-drawer]');
        if (drawer) {
          drawer.querySelectorAll('[data-menu-group].is-open').forEach(function (g) {
            if (g !== group) {
              g.classList.remove('is-open');
              var t = g.querySelector('[data-menu-group-toggle]');
              if (t) t.setAttribute('aria-expanded', 'false');
              var p = g.querySelector('[data-menu-group-panel]');
              if (p) p.style.maxHeight = '0px';
            }
          });
        }

        if (isOpen) {
          group.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          if (panel) panel.style.maxHeight = '0px';
        } else {
          group.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (panel) {
            // Animate to actual content height
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }
      });
    });
  }


  /* ═══════════════════════════════════════════
     Global click handler
     ═══════════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
  });


  /* ═══════════════════════════════════════════
     Escape closes drawer
     ═══════════════════════════════════════════ */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });


  /* ═══════════════════════════════════════════
     Init
     ═══════════════════════════════════════════ */
  function init() {
    initAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify theme editor reloads */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();


/* ═══════════════════════════════════════════
   CART — live updates via Shopify Cart API
   No full page reloads on qty/remove.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var cartPage = document.querySelector('[data-cart-page]');
  if (!cartPage) return;

  var form = cartPage.querySelector('[data-cart-form]');
  if (!form) return;

  /* Currency formatter — pulls store format from Shopify's money format
     helper. Falls back to a simple $X.XX if unavailable. */
  var moneyFormat = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
    ? null
    : null;

  function activeIso() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  }

  function formatMoney(cents) {
    /* Use the value Shopify returns for the line items' final_price_formatted
       whenever possible; this is only for fallback/client-side math display. */
    var amount = (cents / 100);
    // Round to 2 decimals, strip trailing zeros to match money_without_trailing_zeros
    var fixed = amount.toFixed(2);
    if (fixed.endsWith('.00')) fixed = fixed.slice(0, -3);
    var iso = activeIso();
    return '$' + fixed + (iso ? ' <span class="money__iso">' + iso + '</span>' : '');
  }

  var cartAbortController = null;

  function postJSON(url, payload) {
    if (cartAbortController) cartAbortController.abort();
    cartAbortController = new AbortController();
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload),
      signal: cartAbortController.signal
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart API error ' + r.status);
      return r.json();
    });
  }

  function setUpdating(row, on) {
    if (row) row.classList.toggle('is-updating', !!on);
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.classList.toggle('is-updating', !!on);
    });
    var headerCart = document.querySelector('[data-header-cart]');
    if (headerCart) headerCart.classList.toggle('is-updating', !!on);
  }

  function updateSubtotals(cart) {
    var subtotalText = formatMoney(cart.total_price);
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.innerHTML = subtotalText;
    });

    // Header count
    var headerCount = document.querySelector('[data-header-cart-count]');
    if (headerCount) {
      headerCount.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
    }

    // Count label
    var countLabel = document.querySelector('[data-cart-count-label]');
    if (countLabel) {
      if (cart.item_count === 0) {
        countLabel.textContent = 'Empty';
      } else {
        countLabel.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');
      }
    }

    // Update each line's final_line_price from the cart response
    if (cart.items) {
      cart.items.forEach(function (item) {
        var row = document.querySelector('[data-cart-row][data-key="' + item.key + '"]');
        if (!row) return;
        var totalEl = row.querySelector('[data-line-total]');
        if (totalEl) totalEl.innerHTML = formatMoney(item.final_line_price);
        var qtyEl = row.querySelector('[data-cart-qty]');
        if (qtyEl && document.activeElement !== qtyEl) {
          qtyEl.value = item.quantity;
        }
      });
    }

    // If cart became empty, reload so the empty state renders
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  function changeQty(key, qty) {
    var row = document.querySelector('[data-cart-row][data-key="' + key + '"]');
    setUpdating(row, true);
    return postJSON('/cart/change.js', { id: key, quantity: qty })
      .then(function (cart) {
        setUpdating(row, false);
        updateSubtotals(cart);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        setUpdating(row, false);
        console.error(err);
      });
  }

  function removeItem(key) {
    var row = document.querySelector('[data-cart-row][data-key="' + key + '"]');
    if (row) row.classList.add('is-removing');

    // If this was the last remaining item, keep the subtle fade then reload
    setTimeout(function () {
      postJSON('/cart/change.js', { id: key, quantity: 0 })
        .then(function (cart) {
          if (row) row.parentNode.removeChild(row);
          updateSubtotals(cart);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') console.error(err);
          if (row) row.classList.remove('is-removing');
        });
    }, 220);
  }

  /* Debounced handler for typed quantity changes */
  var qtyDebounce = {};
  function handleQtyInput(input) {
    var key = input.dataset.key;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;

    if (qtyDebounce[key]) clearTimeout(qtyDebounce[key]);
    qtyDebounce[key] = setTimeout(function () {
      if (qty === 0) removeItem(key);
      else changeQty(key, qty);
    }, 400);
  }

  /* ── Event delegation ── */
  cartPage.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (stepBtn) {
      e.preventDefault();
      var key = stepBtn.dataset.key;
      var step = parseInt(stepBtn.dataset.qtyStep, 10) || 0;
      var input = cartPage.querySelector('[data-cart-qty][data-key="' + key + '"]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = Math.max(0, current + step);
      input.value = next;
      if (next === 0) removeItem(key);
      else changeQty(key, next);
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      removeItem(removeBtn.dataset.key);
      return;
    }
  });

  cartPage.addEventListener('input', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) handleQtyInput(input);
  });

  /* ── Cart note — debounced save on type ── */
  var noteField = cartPage.querySelector('[data-cart-note]');
  var noteDebounce = null;
  if (noteField) {
    noteField.addEventListener('input', function () {
      if (noteDebounce) clearTimeout(noteDebounce);
      noteDebounce = setTimeout(function () {
        postJSON('/cart/update.js', { note: noteField.value }).catch(function (err) {
          if (err.name !== 'AbortError') console.error(err);
        });
      }, 600);
    });
  }

  /* ── Mobile sticky checkout button → submit the form ── */
  var stickyCheckout = document.querySelector('[data-cart-sticky-checkout]');
  if (stickyCheckout) {
    stickyCheckout.addEventListener('click', function () {
      var checkout = form.querySelector('[data-cart-checkout]');
      if (checkout) checkout.click();
      else form.submit();
    });
  }

  /* ── Prevent Enter in qty input from submitting form ── */
  cartPage.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-cart-qty]')) {
      e.preventDefault();
      e.target.blur();
    }
  });
})();


/* ═══════════════════════════════════════════
   CART DRAWER — side panel with AJAX add/update
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var drawerBody = drawer.querySelector('[data-cart-drawer-body]');

  /* Reuse the scroll lock helpers from the main IIFE by calling
     the same document.body transforms directly. */
  var _drawerScrollY = 0;
  function lockScrollForDrawer() {
    if (document.body.dataset.scrollLocked === 'true') return;
    _drawerScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _drawerScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.dataset.scrollLocked = 'true';
  }
  function unlockScrollForDrawer() {
    if (document.body.dataset.scrollLocked !== 'true') return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.removeAttribute('data-scroll-locked');
    window.scrollTo(0, _drawerScrollY);
  }

  function openDrawer() {
    if (drawer.classList.contains('is-open')) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScrollForDrawer();

    // Focus close button for keyboard users
    var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScrollForDrawer();
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (amount.endsWith('.00')) amount = amount.slice(0, -3);
    var iso = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return '$' + amount + (iso ? ' <span class="money__iso">' + iso + '</span>' : '');
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (data) { throw data; });
      return r.json();
    });
  }

  /* Re-render the drawer body using Shopify's section rendering API.
     This returns the section HTML; we extract [data-cart-drawer-body]
     from it and swap. */
  function refreshDrawer(opts) {
    opts = opts || {};
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data['cart-drawer']) return;
        var html = data['cart-drawer'];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newBody = doc.querySelector('[data-cart-drawer-body]');
        if (newBody && drawerBody) {
          drawerBody.innerHTML = newBody.innerHTML;

          // Animate the newly-added row if a key was provided
          if (opts.highlightKey) {
            var row = drawerBody.querySelector('[data-cart-row][data-key="' + opts.highlightKey + '"]');
            if (row) row.classList.add('is-adding');
          }
        }

        // Update the count label in the drawer head
        var newCount = doc.querySelector('[data-cart-count-label]');
        var drawerCount = drawer.querySelector('[data-cart-count-label]');
        if (newCount && drawerCount) drawerCount.textContent = newCount.textContent;
      });
  }

  function updateHeaderCount(cart) {
    var headerCount = document.querySelector('[data-header-cart-count]');
    if (headerCount) {
      headerCount.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
    }
    var headerCart = document.querySelector('[data-header-cart]');
    if (headerCart) headerCart.classList.remove('is-updating');

    // Update cart page subtotals/counts too (if user is on the cart page)
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.innerHTML = formatMoney(cart.total_price);
    });
  }

  function setDrawerUpdating(row, on) {
    if (row) row.classList.toggle('is-updating', !!on);
    drawer.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.classList.toggle('is-updating', !!on);
    });
  }

  /* ── Drawer qty/remove (event delegation on drawer) ── */
  var drawerQtyDebounce = {};
  function drawerChangeQty(key, qty) {
    var row = drawer.querySelector('[data-cart-row][data-key="' + key + '"]');
    setDrawerUpdating(row, true);
    return postJSON('/cart/change.js', { id: key, quantity: qty })
      .then(function (cart) {
        updateHeaderCount(cart);
        return refreshDrawer();
      })
      .catch(function (err) {
        setDrawerUpdating(row, false);
        console.error(err);
      });
  }

  function drawerRemoveItem(key) {
    var row = drawer.querySelector('[data-cart-row][data-key="' + key + '"]');
    if (row) row.classList.add('is-removing');
    setTimeout(function () {
      postJSON('/cart/change.js', { id: key, quantity: 0 })
        .then(function (cart) {
          updateHeaderCount(cart);
          return refreshDrawer();
        })
        .catch(function (err) { console.error(err); });
    }, 250);
  }

  /* ── Click handlers (delegation) ── */
  document.addEventListener('click', function (e) {
    // Open drawer from anywhere
    if (e.target.closest('[data-cart-drawer-open]')) {
      // On the cart page itself, let the link navigate normally
      if (document.querySelector('[data-cart-page]')) return;
      e.preventDefault();
      // Open immediately for instant feedback, then refresh in the background.
      // Previously we awaited the network round-trip which introduced a
      // noticeable delay before the panel even started animating in.
      openDrawer();
      refreshDrawer().catch(function (err) { console.error(err); });
      return;
    }

    // Close drawer
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    // Qty stepper inside drawer
    var stepBtn = e.target.closest('[data-qty-step]');
    if (stepBtn && drawer.contains(stepBtn)) {
      e.preventDefault();
      var key = stepBtn.dataset.key;
      var step = parseInt(stepBtn.dataset.qtyStep, 10) || 0;
      var input = drawer.querySelector('[data-cart-qty][data-key="' + key + '"]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = Math.max(0, current + step);
      input.value = next;
      if (next === 0) drawerRemoveItem(key);
      else drawerChangeQty(key, next);
      return;
    }

    // Remove button inside drawer
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn && drawer.contains(removeBtn)) {
      e.preventDefault();
      drawerRemoveItem(removeBtn.dataset.key);
      return;
    }
  });

  /* Typed qty in drawer */
  drawer.addEventListener('input', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var key = input.dataset.key;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    if (drawerQtyDebounce[key]) clearTimeout(drawerQtyDebounce[key]);
    drawerQtyDebounce[key] = setTimeout(function () {
      if (qty === 0) drawerRemoveItem(key);
      else drawerChangeQty(key, qty);
    }, 400);
  });

  /* Enter in qty input blurs instead of submitting */
  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-cart-qty]')) {
      e.preventDefault();
      e.target.blur();
    }
    if (e.key === 'Escape') closeDrawer();
  });


  /* ═══════════════════════════════════════════
     PRODUCT FORM — intercept Add to cart
     ═══════════════════════════════════════════ */
  var productForms = document.querySelectorAll('[data-product-form-wrap] form[action*="/cart/add"]');
  productForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var button = form.querySelector('[data-add-to-cart]');
      var label = button ? button.querySelector('[data-add-label]') : null;
      var originalLabel = label ? label.textContent : 'Add to cart';

      if (button) {
        button.classList.add('is-adding');
        button.disabled = true;
        if (label) label.textContent = 'Adding...';
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return r.json();
      })
      .then(function (addedItem) {
        // The added item's "key" lives on the response; use it to highlight
        var key = addedItem.key;

        // Refresh global cart data for header count + drawer body
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateHeaderCount(cart);
            return refreshDrawer({ highlightKey: key });
          });
      })
      .then(function () {
        openDrawer();
        if (button) {
          button.classList.remove('is-adding');
          button.classList.add('was-added');
          if (label) label.textContent = 'Added';
          setTimeout(function () {
            button.classList.remove('was-added');
            button.disabled = false;
            if (label) label.textContent = originalLabel;
          }, 1200);
        }
      })
      .catch(function (err) {
        console.error(err);
        if (button) {
          button.classList.remove('is-adding');
          button.disabled = false;
          if (label) label.textContent = originalLabel;
        }
        // If something went wrong (e.g., sold out), fall back to native submit
        // so the merchant sees Shopify's actual error page
        var errMsg = (err && err.description) || (err && err.message) || 'Could not add to cart.';
        alert(errMsg);
      });
    });
  });

})();


/* ═══════════════════════════════════════════
   COLLECTION FILTERS — URL-param driven
   On input change, rebuild the URL from the form's checkbox state and
   navigate. Shopify re-renders with the filter params applied.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var form = document.getElementById('FacetFiltersForm');
  if (!form) return;

  function buildAndGo() {
    // Collect checked filter inputs. Multiple values with the same name are
    // preserved (e.g. filter.v.option.size=S&filter.v.option.size=M).
    var params = new URLSearchParams();
    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      if (input.checked && input.name) {
        params.append(input.name, input.value);
      }
    });

    // Preserve the existing sort_by if present on the page URL
    var currentParams = new URLSearchParams(window.location.search);
    var sort = currentParams.get('sort_by');
    if (sort) params.set('sort_by', sort);

    var qs = params.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    window.location.href = url;
  }

  var debounce = null;
  form.addEventListener('change', function (e) {
    if (!e.target.matches('input[type="checkbox"]')) return;
    // Slight debounce in case the user clicks multiple boxes quickly
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(buildAndGo, 120);
  });

  // Prevent the raw form submit from POSTing — we handle it via the change
  // handler above. (There's no submit button in the markup, but guard anyway.)
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    buildAndGo();
  });
})();


/* ═══════════════════════════════════════════
   PRODUCT VARIANT RESOLUTION
   Reads the embedded variant JSON and, on option change, resolves the
   matching variant, updates the hidden id, updates the price, toggles
   the button's sold-out state, and marks sold-out size pills.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var formWrap = document.querySelector('[data-product-form-wrap]');
  if (!formWrap) return;

  var jsonEl = document.querySelector('[data-product-variants-json]');
  if (!jsonEl) return;

  var variants;
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (err) {
    console.error('Bad product variants JSON', err);
    return;
  }
  if (!Array.isArray(variants) || !variants.length) return;

  var form = formWrap.querySelector('form');
  if (!form) return;
  var hiddenId = form.querySelector('[data-variant-id]');
  var button = form.querySelector('[data-add-to-cart]');
  var label = button ? button.querySelector('[data-add-label]') : null;
  var priceEl = document.querySelector('[data-current-price]');
  var compareEl = document.querySelector('[data-compare-price]');

  // Capture the merchant-customized labels rendered by Liquid so we
  // can restore them after variant changes instead of hardcoding strings.
  var INITIAL_AVAILABLE_LABEL = (label && label.textContent || 'Add to cart').trim();
  var INITIAL_SOLDOUT_LABEL = 'Sold out';
  if (button && button.disabled && label) {
    // If the page rendered with a sold-out variant selected, the label
    // already shows the sold-out text — capture it for that side too.
    INITIAL_SOLDOUT_LABEL = (label.textContent || 'Sold out').trim();
  }
  // We can't have both initial states at once on first render, so for
  // whichever state DIDN'T render we fall back to a sensible default.
  // The merchant can override these via section settings later.

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (amount.endsWith('.00')) amount = amount.slice(0, -3);
    var iso = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return '$' + amount + (iso ? ' <span class="money__iso">' + iso + '</span>' : '');
  }

  function getSelectedOptions() {
    var selected = [];
    form.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
      var idx = parseInt(fs.dataset.optionIndex, 10);
      // Pills use radios, other options use <select>
      var checkedRadio = fs.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        selected[idx] = checkedRadio.value;
        return;
      }
      var select = fs.querySelector('select');
      if (select) selected[idx] = select.value;
    });
    return selected;
  }

  function findVariant(selected) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < selected.length; j++) {
        if (selected[j] !== v.options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateSizePillAvailability() {
    // For each Size pill, check whether ANY variant combining that size with
    // the currently-selected other options is available. Mark sold out visually
    // but keep them clickable (user may want to see other unavailable combos).
    var selected = getSelectedOptions();
    form.querySelectorAll('.product-grid-page__field--pills').forEach(function (fs) {
      var idx = parseInt(fs.dataset.optionIndex, 10);
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var testCombo = selected.slice();
        testCombo[idx] = input.value;
        var anyAvailable = false;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var allMatch = true;
          for (var j = 0; j < testCombo.length; j++) {
            if (testCombo[j] === undefined) continue;
            if (testCombo[j] !== v.options[j]) { allMatch = false; break; }
          }
          if (allMatch && v.available) { anyAvailable = true; break; }
        }
        var pillLabel = fs.querySelector('label[for="' + input.id + '"]');
        if (pillLabel) {
          pillLabel.classList.toggle('product-grid-page__pill--soldout', !anyAvailable);
        }
      });
    });
  }

  function updateForVariant(variant) {
    if (!variant) {
      if (button) {
        button.disabled = true;
        if (label) label.textContent = 'Unavailable';
      }
      return;
    }

    if (hiddenId) hiddenId.value = variant.id;

    if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.innerHTML = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (button) {
      if (variant.available) {
        button.disabled = false;
        if (label) label.textContent = INITIAL_AVAILABLE_LABEL;
      } else {
        button.disabled = true;
        if (label) label.textContent = INITIAL_SOLDOUT_LABEL;
      }
    }

    // Keep URL variant param in sync (nice-to-have; lets customers share
    // links that preselect the variant on reload).
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    } catch (err) { /* ignore */ }
  }

  function onChange() {
    var selected = getSelectedOptions();
    var variant = findVariant(selected);
    updateForVariant(variant);
    updateSizePillAvailability();
  }

  /* ── Color swatches: filter the gallery to show only the selected color's media ── */

  // Build a map of color value -> Set of media ids linked to any variant
  // of that color, MERGED with media whose alt text matches the color
  // name (case-insensitive). This lets a product show multiple photos
  // per color without having to spawn a unique variant per image.
  var colorOptionIndex = -1;
  var colorMediaMap = {};   // { 'Vintage Grey': { 1234: true, 5678: true }, ... }
  var allTileIds = [];

  // Parse the optional media-with-alt JSON block (newer markup) so we
  // can group by alt text. Falls back gracefully if the block is missing.
  var mediaList = [];
  var mediaJsonEl = document.querySelector('[data-product-media-json]');
  if (mediaJsonEl) {
    try { mediaList = JSON.parse(mediaJsonEl.textContent) || []; }
    catch (err) { mediaList = []; }
  }

  function normalizeColor(s) {
    return String(s || '').trim().toLowerCase();
  }

  (function buildColorMediaMap() {
    // Find which option index corresponds to the color swatches fieldset
    var swatchFieldset = form.querySelector('.product-grid-page__field--swatches');
    if (!swatchFieldset) return;
    colorOptionIndex = parseInt(swatchFieldset.dataset.optionIndex, 10);
    if (isNaN(colorOptionIndex)) { colorOptionIndex = -1; return; }

    // Collect every distinct color value present on this product
    var colorValues = {};
    variants.forEach(function (v) {
      var c = v.options[colorOptionIndex];
      if (c) colorValues[c] = true;
    });

    // If there's only ONE color value, color filtering is meaningless and
    // would just hide media that doesn't match the lone color's name.
    // Disable filtering by leaving colorOptionIndex at -1 so all media
    // stays visible and the FOUC-prevention layer reveals everything.
    if (Object.keys(colorValues).length <= 1) {
      colorOptionIndex = -1;
      return;
    }

    // 1) Seed the map with each variant's assigned featured image
    variants.forEach(function (v) {
      if (!v.featured_media_id) return;
      var color = v.options[colorOptionIndex];
      if (!color) return;
      if (!colorMediaMap[color]) colorMediaMap[color] = {};
      colorMediaMap[color][v.featured_media_id] = true;
    });

    // 2) For every product media item, parse its alt text into tokens
    //    (split on '|' and '-') and match each token against known color
    //    values. This way alt text like 'Black | front' tags the photo
    //    as Black, while 'front'/'back' tokens are reserved for the
    //    on-tile view label. Falls back to whole-string match for
    //    backwards-compat when the alt is just 'Black'.
    mediaList.forEach(function (m) {
      if (!m.alt) return;
      // Split on common separators; trim and normalize each token
      var tokens = String(m.alt).split(/[|\-/,;]+/).map(normalizeColor).filter(Boolean);
      if (!tokens.length) return;
      Object.keys(colorValues).forEach(function (color) {
        var colorNorm = normalizeColor(color);
        // Match if any token equals the color name OR the whole alt equals it
        var matches = tokens.indexOf(colorNorm) !== -1 || normalizeColor(m.alt) === colorNorm;
        if (matches) {
          if (!colorMediaMap[color]) colorMediaMap[color] = {};
          colorMediaMap[color][m.id] = true;
        }
      });
    });

    // Snapshot every tile id on the page so we can fall back to "show all"
    document.querySelectorAll('.product-grid-page__tile[data-media-id]').forEach(function (t) {
      allTileIds.push(t.getAttribute('data-media-id'));
    });
  })();

  function filterGalleryByColor(colorValue) {
    if (colorOptionIndex < 0) return;
    var allowedIds = colorMediaMap[colorValue] || {};

    var tiles = document.querySelectorAll('.product-grid-page__tile[data-media-id]');
    if (!tiles.length) return;

    // Defensive check: count distinct colors in variants. If there's only
    // one (or zero), the filter is meaningless — just show everything.
    // This catches edge cases where buildColorMediaMap's single-color
    // bypass didn't run (e.g., the swatch fieldset markup was edited).
    var distinctColors = {};
    variants.forEach(function (v) {
      var c = v.options[colorOptionIndex];
      if (c) distinctColors[c] = true;
    });
    if (Object.keys(distinctColors).length <= 1) {
      tiles.forEach(function (tile) {
        tile.hidden = false;
        tile.classList.remove('is-variant-hidden');
      });
      rebuildDots();
      return;
    }

    // Strict filtering: only show tiles whose id is in the allowed set
    // for this specific color. We deliberately do NOT fall back to
    // "show everything" when a color has no mapping — that mixes the
    // colors together, which is the bug we're avoiding. A color with
    // no linked media will simply show nothing; the fix in that case
    // is to either (a) set the variant image in admin, or (b) set the
    // image's alt text to match the color name.
    var anyVisible = false;
    tiles.forEach(function (tile) {
      var id = tile.getAttribute('data-media-id');
      if (allowedIds[id]) {
        tile.hidden = false;
        tile.classList.remove('is-variant-hidden');
        anyVisible = true;
      } else {
        tile.hidden = true;
        tile.classList.add('is-variant-hidden');
      }
    });

    // Last-ditch fallback: if a color genuinely has zero linked media
    // (no variant featured image and no alt-text matches), show the
    // first product tile as a placeholder so the gallery isn't blank.
    if (!anyVisible && tiles.length) {
      tiles[0].hidden = false;
      tiles[0].classList.remove('is-variant-hidden');
    }

    // Reset the mobile carousel back to the first image of the new color
    // and rebuild the dots strip to match the visible count.
    var media = document.querySelector('[data-product-media]');
    if (media) {
      // 'auto' (instant) jump avoids a smooth scroll across the diff.
      try { media.scrollTo({ left: 0, top: 0, behavior: 'auto' }); }
      catch (e) { media.scrollLeft = 0; }
    }
    rebuildDots();

    // On desktop (no horizontal carousel), scroll the user to the
    // gallery top if it's offscreen so the swap is visible.
    if (anyVisible && media && getComputedStyle(media).overflowX !== 'auto') {
      var firstVisible = document.querySelector('.product-grid-page__tile:not([hidden])');
      if (firstVisible) {
        var rect = firstVisible.getBoundingClientRect();
        if (rect.top < 0 || rect.top > (window.innerHeight || document.documentElement.clientHeight) * 0.5) {
          firstVisible.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }

  /* ── Mobile carousel dots ── */
  var dotsEl = document.querySelector('[data-gallery-dots]');
  var mediaEl = document.querySelector('[data-product-media]');

  function rebuildDots() {
    if (!mediaEl) return;
    var visibleTiles = mediaEl.querySelectorAll('.product-grid-page__tile:not([hidden]):not(.is-variant-hidden)');

    // Toggle the single-image desktop layout class so a lone tile gets
    // a larger, balanced placement instead of hanging in column 1.
    mediaEl.classList.toggle('is-single', visibleTiles.length === 1);

    if (!dotsEl) return;
    if (visibleTiles.length <= 1) {
      dotsEl.innerHTML = '';
      return;
    }
    var html = '';
    for (var i = 0; i < visibleTiles.length; i++) {
      html += '<button type="button" class="product-grid-page__dot' + (i === 0 ? ' is-active' : '') +
              '" data-dot-index="' + i + '" aria-label="Go to image ' + (i + 1) + '"></button>';
    }
    dotsEl.innerHTML = html;
  }

  function updateActiveDot() {
    if (!dotsEl || !mediaEl) return;
    var dots = dotsEl.querySelectorAll('.product-grid-page__dot');
    if (!dots.length) return;
    // Determine which tile is most centered in the scroll viewport
    var visibleTiles = mediaEl.querySelectorAll('.product-grid-page__tile:not([hidden]):not(.is-variant-hidden)');
    var scrollMid = mediaEl.scrollLeft + mediaEl.clientWidth / 2;
    var bestIdx = 0;
    var bestDist = Infinity;
    for (var i = 0; i < visibleTiles.length; i++) {
      var t = visibleTiles[i];
      var tileMid = t.offsetLeft + t.offsetWidth / 2;
      var d = Math.abs(tileMid - scrollMid);
      if (d < bestDist) { bestDist = d; bestIdx = i; }
    }
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === bestIdx);
    });
  }

  if (mediaEl) {
    var scrollRaf = null;
    mediaEl.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        updateActiveDot();
        scrollRaf = null;
      });
    }, { passive: true });
  }

  if (dotsEl) {
    dotsEl.addEventListener('click', function (e) {
      var dot = e.target.closest('.product-grid-page__dot');
      if (!dot || !mediaEl) return;
      var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
      if (isNaN(idx)) return;
      var visibleTiles = mediaEl.querySelectorAll('.product-grid-page__tile:not([hidden]):not(.is-variant-hidden)');
      var target = visibleTiles[idx];
      if (target) {
        mediaEl.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    });
  }

  function onColorSwatchChange(input) {
    // Update the "Colour: Vintage Grey" label next to the legend
    var fieldset = input.closest('fieldset[data-option-index]');
    if (fieldset) {
      var labelValue = fieldset.querySelector('[data-selected-color]');
      if (labelValue) labelValue.textContent = ': ' + input.value;
    }
    // Filter gallery to this color's images
    filterGalleryByColor(input.value);
  }

  // Apply the initial filter on load so the gallery matches the
  // pre-selected color (e.g. when arriving via ?variant= URL).
  // Then mark the media wrapper as 'ready' so the FOUC-prevention CSS
  // releases its hide-by-default rule and the correctly-filtered tiles
  // become visible.
  (function applyInitialColorFilter() {
    if (colorOptionIndex < 0) {
      // No color option — still build dots for the full gallery on mobile
      rebuildDots();
    } else {
      var checked = form.querySelector('.product-grid-page__swatch-input:checked');
      if (checked) filterGalleryByColor(checked.value);
      else rebuildDots();
    }
    // Reveal the gallery now that filtering is done. Use rAF so the
    // browser has painted the hidden state at least once before the
    // reveal animation runs — keeps the fade smooth.
    var media = document.querySelector('[data-product-media]');
    if (media) {
      requestAnimationFrame(function () {
        media.classList.add('is-ready');
      });
    }
  })();

  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-option-value], input[type="radio"][name^="options"]')) {
      onChange();
      if (e.target.matches('.product-grid-page__swatch-input')) {
        onColorSwatchChange(e.target);
      }
    }
  });

  // Initial pass so sold-out pills are marked on load
  updateSizePillAvailability();
})();


/* ═══════════════════════════════════════════
   CUSTOMER — login/recover toggle,
   address edit toggle, address delete,
   country/province linking.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Login <-> Recover password toggle ── */
  var loginForm = document.querySelector('[data-login-form]');
  var recoverForm = document.querySelector('[data-recover-form]');
  var loginTitle = document.querySelector('[data-login-title]');

  function showRecover() {
    if (loginForm) loginForm.hidden = true;
    if (recoverForm) recoverForm.hidden = false;
    if (loginTitle) loginTitle.textContent = 'Reset password';
  }
  function showLogin() {
    if (loginForm) loginForm.hidden = false;
    if (recoverForm) recoverForm.hidden = true;
    if (loginTitle) loginTitle.textContent = 'Sign in';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-recover-toggle]')) {
      e.preventDefault();
      showRecover();
    }
    if (e.target.closest('[data-recover-cancel]')) {
      e.preventDefault();
      showLogin();
    }
  });

  /* If the recover form has errors or was just submitted successfully,
     show it by default (Shopify reloads the same page with form state). */
  if (recoverForm) {
    var hasRecoverState =
      recoverForm.querySelector('.customer-form__errors') ||
      recoverForm.querySelector('.customer-form__success');
    if (hasRecoverState || window.location.hash === '#recover') {
      showRecover();
    }
  }


  /* ── Address edit toggle ── */
  document.addEventListener('click', function (e) {
    var editBtn = e.target.closest('[data-address-edit-toggle]');
    if (editBtn) {
      e.preventDefault();
      var id = editBtn.dataset.addressEditToggle;
      var panel = document.querySelector('[data-address-edit="' + id + '"]');
      if (panel) {
        panel.hidden = !panel.hidden;
      }
      return;
    }

    var cancelBtn = e.target.closest('[data-address-edit-cancel]');
    if (cancelBtn) {
      e.preventDefault();
      var cancelId = cancelBtn.dataset.addressEditCancel;
      var cancelPanel = document.querySelector('[data-address-edit="' + cancelId + '"]');
      if (cancelPanel) cancelPanel.hidden = true;
      return;
    }

    var delBtn = e.target.closest('[data-address-delete]');
    if (delBtn) {
      e.preventDefault();
      if (!window.confirm('Delete this address?')) return;
      var url = delBtn.dataset.addressUrl;
      if (!url) return;
      // Shopify expects a POST with _method=delete for address deletion
      var formData = new FormData();
      formData.append('_method', 'delete');
      formData.append('authenticity_token',
        document.querySelector('meta[name="csrf-token"]') ?
          document.querySelector('meta[name="csrf-token"]').content : '');
      fetch(url, { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function () { window.location.reload(); })
        .catch(function (err) { console.error(err); });
      return;
    }
  });

  /* ── Country / Province linking ──
     Uses Shopify's built-in Countries JSON rendered in country_option_tags.
     Each country <option> has a data-provinces attribute with a JSON array.
  */
  function initCountryProvince() {
    var countrySelects = document.querySelectorAll('[data-country-select]');
    countrySelects.forEach(function (countrySelect) {
      // Set the default country if specified
      var defaultCountry = countrySelect.dataset.default;
      if (defaultCountry) {
        var matchOption = Array.from(countrySelect.options).find(function (o) {
          return o.value === defaultCountry;
        });
        if (matchOption) countrySelect.value = defaultCountry;
      }

      var wrapper = countrySelect.closest('form, [data-address-edit], .customer-addresses__new');
      if (!wrapper) return;
      var provinceSelect = wrapper.querySelector('[data-province-select]');
      var provinceWrapper = wrapper.querySelector('[data-province-wrapper]');
      if (!provinceSelect || !provinceWrapper) return;

      function populateProvinces() {
        var selectedOption = countrySelect.options[countrySelect.selectedIndex];
        if (!selectedOption) {
          provinceWrapper.style.display = 'none';
          return;
        }
        var rawProvinces = selectedOption.dataset.provinces;
        if (!rawProvinces) {
          provinceWrapper.style.display = 'none';
          return;
        }
        var provinces = [];
        try { provinces = JSON.parse(rawProvinces); } catch (err) { provinces = []; }

        if (!provinces.length) {
          provinceSelect.innerHTML = '';
          provinceWrapper.style.display = 'none';
          return;
        }

        provinceWrapper.style.display = '';
        provinceSelect.innerHTML = provinces.map(function (p) {
          return '<option value="' + p[0] + '">' + p[1] + '</option>';
        }).join('');

        var defaultProvince = provinceSelect.dataset.default;
        if (defaultProvince) {
          var match = Array.from(provinceSelect.options).find(function (o) {
            return o.value === defaultProvince;
          });
          if (match) provinceSelect.value = defaultProvince;
        }
      }

      countrySelect.addEventListener('change', populateProvinces);
      populateProvinces();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountryProvince);
  } else {
    initCountryProvince();
  }

})();


/* ═══════════════════════════════════════════
   CONTACT EDITORIAL — tabs, autogrow, validation, submit state
   Two forms on one page (Feedback / Orders). Tab clicks animate panel
   swaps and an underline indicator that slides between tab labels.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.querySelector('[data-contact-root]');
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-contact-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-contact-panel]'));
  var indicator = root.querySelector('[data-contact-tab-indicator]');

  /* ── Textarea autogrow ── */
  function autogrow(ta) {
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + 'px';
  }
  root.querySelectorAll('.contact-editorial__input--textarea').forEach(function (ta) {
    ta.addEventListener('input', function () { autogrow(ta); });
    autogrow(ta);
  });

  /* ── Tab indicator positioning ── */
  function positionIndicator(targetTab, animate) {
    if (!indicator || !targetTab) return;
    var tabsRect = targetTab.parentElement.getBoundingClientRect();
    var tabRect = targetTab.getBoundingClientRect();
    var left = tabRect.left - tabsRect.left;
    var width = tabRect.width;

    if (!animate) {
      var prev = indicator.style.transition;
      indicator.style.transition = 'none';
      indicator.style.width = width + 'px';
      indicator.style.transform = 'translateX(' + left + 'px)';
      // Force reflow so subsequent changes animate again
      indicator.offsetHeight;
      indicator.style.transition = prev;
    } else {
      indicator.style.width = width + 'px';
      indicator.style.transform = 'translateX(' + left + 'px)';
    }
  }

  function getActiveTab() {
    return tabs.find(function (t) { return t.classList.contains('is-active'); });
  }

  /* Place indicator on first paint under the currently-active tab */
  function initIndicator() {
    var active = getActiveTab();
    if (active) positionIndicator(active, false);
  }
  initIndicator();
  // Reposition on resize (tabs may shift width if labels change)
  window.addEventListener('resize', function () {
    var active = getActiveTab();
    if (active) positionIndicator(active, false);
  });

  /* ── Switch tabs with a tight fade/slide ──
     shouldFocus: only true when user explicitly clicks a tab.
     On hash-sync / load, we skip focus so Safari doesn't auto-surface
     its autofill overlay and plant the user's email in the field. */
  function switchTo(name, shouldFocus) {
    var currentPanel = panels.find(function (p) { return p.dataset.contactPanel !== name && !p.hidden; });
    var nextPanel    = panels.find(function (p) { return p.dataset.contactPanel === name; });
    if (!nextPanel || nextPanel === currentPanel) return;

    // Update tabs
    tabs.forEach(function (t) {
      var isActive = t.dataset.contactTab === name;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    // Slide indicator
    var nextTab = tabs.find(function (t) { return t.dataset.contactTab === name; });
    if (nextTab) positionIndicator(nextTab, true);

    // Update URL so a reload or share keeps the selected tab
    try {
      var url = new URL(window.location.href);
      if (name === 'feedback') url.searchParams.delete('form');
      else url.searchParams.set('form', name);
      window.history.replaceState({}, '', url);
    } catch (e) { /* ignore */ }

    // Animate panel swap
    if (currentPanel) {
      currentPanel.classList.remove('is-active');
      currentPanel.classList.add('is-leaving');
      setTimeout(function () {
        currentPanel.hidden = true;
        currentPanel.classList.remove('is-leaving');

        nextPanel.hidden = false;
        nextPanel.classList.add('is-entering');
        // Force reflow so the entering state applies before the active class
        nextPanel.offsetHeight;
        nextPanel.classList.remove('is-entering');
        nextPanel.classList.add('is-active');

        // Recompute autogrow for the now-visible textarea
        nextPanel.querySelectorAll('.contact-editorial__input--textarea').forEach(autogrow);
        // Only focus when the user explicitly clicked a tab
        if (shouldFocus) {
          var first = nextPanel.querySelector('.contact-editorial__input');
          if (first) first.focus({ preventScroll: true });
        }
      }, 180);
    } else {
      nextPanel.hidden = false;
      nextPanel.classList.add('is-active');
    }
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      switchTo(t.dataset.contactTab, true);
    });
  });

  /* ── On load: honour URL hash set by Shopify after form submit ──
     Shopify redirects to /pages/contact#FeedbackForm (or #OrdersForm)
     after processing — we use that to open the correct tab client-side
     regardless of what the initial server render chose. No focus here:
     Safari's autofill would open an overlay on load, which is annoying. */
  (function syncFromHash() {
    var h = window.location.hash;
    if (h === '#OrdersForm') {
      var onOrders = tabs.some(function (t) {
        return t.dataset.contactTab === 'orders' && t.classList.contains('is-active');
      });
      if (!onOrders) switchTo('orders', false);
    } else if (h === '#FeedbackForm') {
      var onFeedback = tabs.some(function (t) {
        return t.dataset.contactTab === 'feedback' && t.classList.contains('is-active');
      });
      if (!onFeedback) switchTo('feedback', false);
    }
  })();

  // Keyboard: left/right arrows between tabs
  root.querySelector('.contact-editorial__tabs').addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault();
    var active = getActiveTab();
    var idx = tabs.indexOf(active);
    var next = e.key === 'ArrowRight'
      ? tabs[(idx + 1) % tabs.length]
      : tabs[(idx - 1 + tabs.length) % tabs.length];
    if (next) { next.focus(); switchTo(next.dataset.contactTab); }
  });


  /* ── Inline validation (quiet — only on blur, only if touched) ── */
  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function validate(field) {
    var rule = field.dataset.validate;
    if (!rule) return { ok: true };
    var val = (field.value || '').trim();
    if (rule === 'required' && !val) return { ok: false };
    if (rule === 'email') {
      if (!val) return { ok: false };
      if (!emailRe.test(val)) return { ok: false };
    }
    return { ok: true };
  }

  function applyState(field, result) {
    var wrap = field.closest('.contact-editorial__field');
    if (!wrap) return;
    wrap.classList.toggle('has-error', !result.ok);
    wrap.classList.toggle('is-ok', result.ok);
  }

  root.querySelectorAll('[data-validate]').forEach(function (field) {
    field.addEventListener('blur', function () {
      if (!field.value) return;
      applyState(field, validate(field));
    });
    field.addEventListener('input', function () {
      var wrap = field.closest('.contact-editorial__field');
      if (wrap && wrap.classList.contains('has-error')) {
        applyState(field, validate(field));
      }
    });
  });

  /* ── Submit: validate current panel only ── */
  root.querySelectorAll('.contact-editorial__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var firstInvalid = null;
      form.querySelectorAll('[data-validate]').forEach(function (field) {
        var res = validate(field);
        applyState(field, res);
        if (!res.ok && !firstInvalid) firstInvalid = field;
      });
      if (firstInvalid) {
        e.preventDefault();
        firstInvalid.focus();
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var btn = form.querySelector('[data-contact-submit]');
      var lbl = form.querySelector('[data-submit-label]');
      if (btn) btn.classList.add('is-sending');
      if (lbl) lbl.textContent = 'Sending';
    });
  });

  /* ── Success acknowledgement: scroll into view on server reload ── */
  var ack = root.querySelector('.contact-editorial__ack');
  if (ack) {
    setTimeout(function () {
      ack.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 60);
  }

})();


/* ═══════════════════════════════════════════
   LIGHTBOX — fullscreen product image viewer
   Click/tap any product image to open. Arrow keys / swipe to navigate.
   Tap backdrop, press Escape, or swipe down to close.
   Reuses the existing body scroll-lock helpers via inline copies.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var lightbox = document.querySelector('[data-lightbox]');
  if (!lightbox) return;

  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-lightbox-trigger]'));
  if (!triggers.length) return;

  var img      = lightbox.querySelector('[data-lightbox-img]');
  var stage    = lightbox.querySelector('[data-lightbox-stage]');
  var counter  = lightbox.querySelector('[data-lightbox-counter]');
  var btnPrev  = lightbox.querySelector('[data-lightbox-prev]');
  var btnNext  = lightbox.querySelector('[data-lightbox-next]');

  /* Build an ordered list of images from the triggers. */
  var images = triggers.map(function (t) {
    return {
      src: t.dataset.lightboxSrc,
      alt: t.dataset.lightboxAlt || ''
    };
  });

  var currentIndex = 0;
  var isOpen = false;
  var savedScrollY = 0;

  /* ── Scroll lock (iOS-safe) ── */
  function lock() {
    if (document.body.dataset.scrollLocked === 'true') return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.dataset.scrollLocked = 'true';
  }
  function unlock() {
    if (document.body.dataset.scrollLocked !== 'true') return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.removeAttribute('data-scroll-locked');
    window.scrollTo(0, savedScrollY);
  }

  /* ── Preload adjacent images for snappy nav ── */
  function preload(i) {
    if (i < 0 || i >= images.length) return;
    var p = new Image();
    p.src = images[i].src;
  }

  function updateNav() {
    if (btnPrev) btnPrev.disabled = currentIndex <= 0;
    if (btnNext) btnNext.disabled = currentIndex >= images.length - 1;
    if (counter) {
      if (images.length > 1) {
        counter.textContent = (currentIndex + 1) + ' / ' + images.length;
        counter.style.display = '';
      } else {
        counter.style.display = 'none';
      }
    }
  }

  function show(index) {
    if (index < 0 || index >= images.length) return;
    currentIndex = index;
    var item = images[currentIndex];

    lightbox.classList.add('is-loading');
    // Reset any swipe transform from a previous gesture
    img.style.transform = '';

    var loader = new Image();
    loader.onload = function () {
      img.src = item.src;
      img.alt = item.alt;
      lightbox.classList.remove('is-loading');
    };
    loader.onerror = function () {
      // Fallback: set src directly so the user at least sees a broken image
      img.src = item.src;
      img.alt = item.alt;
      lightbox.classList.remove('is-loading');
    };
    loader.src = item.src;

    updateNav();
    preload(currentIndex + 1);
    preload(currentIndex - 1);
  }

  function open(index) {
    if (isOpen) return;
    isOpen = true;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    lock();
    show(index);

    // Focus the close button so keyboard users can dismiss easily
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    if (closeBtn) setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, 50);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    lightbox.classList.remove('is-open', 'is-loading', 'is-swiping');
    lightbox.setAttribute('aria-hidden', 'true');
    img.style.transform = '';
    unlock();
  }

  function next() {
    if (currentIndex < images.length - 1) show(currentIndex + 1);
  }
  function prev() {
    if (currentIndex > 0) show(currentIndex - 1);
  }

  /* ── Bind triggers ── */
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var idx = parseInt(trigger.dataset.lightboxIndex, 10) || 0;
      open(idx);
    });
  });

  /* ── Close ── */
  lightbox.addEventListener('click', function (e) {
    if (e.target.closest('[data-lightbox-close]')) {
      close();
      return;
    }
    // Clicks on the stage but outside the image close the lightbox
    if (e.target === stage || e.target === lightbox) {
      close();
    }
  });

  /* ── Nav buttons ── */
  if (btnPrev) btnPrev.addEventListener('click', function (e) { e.preventDefault(); prev(); });
  if (btnNext) btnNext.addEventListener('click', function (e) { e.preventDefault(); next(); });

  /* ── Keyboard ── */
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
    else if (e.key === 'ArrowLeft')  { e.preventDefault(); prev(); }
  });

  /* ── Touch: horizontal swipe = nav, vertical swipe down = close ── */
  var touchStart = null;
  var touchMoved = false;

  stage.addEventListener('touchstart', function (e) {
    if (!isOpen || !e.touches || e.touches.length !== 1) return;
    touchStart = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
    touchMoved = false;
    lightbox.classList.add('is-swiping');
  }, { passive: true });

  // If a 2nd finger arrives, the user is pinching the image — kill any
  // swipe state we'd built up from the 1st finger so we don't fire a
  // spurious next/prev/close when fingers lift after the pinch.
  // (The pinch handler owns the image transform — don't touch it here.)
  stage.addEventListener('touchstart', function (e) {
    if (e.touches && e.touches.length >= 2 && touchStart) {
      touchStart = null;
      lightbox.classList.remove('is-swiping');
      lightbox.style.background = '';
    }
  }, { passive: true });

  stage.addEventListener('touchmove', function (e) {
    if (!touchStart || !e.touches || e.touches.length !== 1) return;
    var dx = e.touches[0].clientX - touchStart.x;
    var dy = e.touches[0].clientY - touchStart.y;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) touchMoved = true;

    // Apply a subtle follow transform so the gesture feels live.
    // Dampen so the image doesn't fully track the finger — feels more controlled.
    var followX = dx * 0.35;
    var followY = Math.max(0, dy) * 0.5;  // only follow downward pulls
    img.style.transform = 'translate(' + followX + 'px, ' + followY + 'px)';

    // If the user is clearly pulling down (vertical dominant), fade the backdrop
    if (dy > 20 && Math.abs(dy) > Math.abs(dx)) {
      var fade = Math.max(0, 1 - dy / 400);
      lightbox.style.background = 'rgba(0, 0, 0, ' + (0.92 * fade) + ')';
    }
  }, { passive: true });

  stage.addEventListener('touchend', function (e) {
    if (!touchStart) return;
    var endTouch = (e.changedTouches && e.changedTouches[0]) || null;
    var dx = endTouch ? endTouch.clientX - touchStart.x : 0;
    var dy = endTouch ? endTouch.clientY - touchStart.y : 0;
    var dt = Date.now() - touchStart.t;
    var absDx = Math.abs(dx);
    var absDy = Math.abs(dy);

    lightbox.classList.remove('is-swiping');
    lightbox.style.background = '';
    img.style.transform = '';

    // Swipe down to close — vertical distance dominant and meaningful
    if (dy > 120 && absDy > absDx) {
      close();
    }
    // Swipe horizontal to navigate — more than 60px or a fast flick
    else if (absDx > 60 && absDx > absDy && (absDx > 100 || dt < 300)) {
      if (dx < 0) next();
      else prev();
    }

    touchStart = null;
  });

})();


/* ═══════════════════════════════════════════
   PINCH-TO-ZOOM — applied to the lightbox image and to product-page
   mobile carousel tiles. Spring-back-to-center model (controlled,
   editorial — no free-pan rubber-banding). Uses the brand --ease curve
   for the release animation so it matches everything else.

   Mechanics:
   - Two-finger touchstart: capture the midpoint and initial distance,
     freeze any transitions on the target image, set is-pinching.
   - Two-finger touchmove: compute the new distance ratio and update
     transform = translate(panX, panY) scale(scale). The single-finger
     position during the gesture provides incremental pan (one-finger
     pan only works WHILE the second finger is also touching — i.e. it's
     part of the pinch, not a separate gesture).
   - touchend (any finger up that drops us below 2 touches): release
     is-pinching, clear the transform, and the CSS transition with
     var(--ease) animates the spring-back over the target's own
     transition duration (.3s for lightbox, .5s for product tiles).
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var MAX_SCALE = 4;
  var MIN_SCALE = 1;

  // distance between two Touch points
  function dist(t1, t2) {
    var dx = t2.clientX - t1.clientX;
    var dy = t2.clientY - t1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }
  // midpoint between two Touch points
  function mid(t1, t2) {
    return { x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 };
  }

  function attachPinch(target, opts) {
    if (!target) return;
    opts = opts || {};
    var onPinchStart = opts.onPinchStart || function () {};
    var onPinchEnd = opts.onPinchEnd || function () {};
    var maxScale = opts.maxScale || MAX_SCALE;

    var state = null; // { startDist, startMid, startScale, scale, panX, panY }

    function applyTransform(s, x, y) {
      target.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(' + s + ')';
    }

    function reset() {
      target.style.transform = '';
      target.classList.remove('is-pinching');
      // Restore default touch behaviour on the target
      target.style.touchAction = '';
      state = null;
      onPinchEnd();
    }

    target.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length < 2) return;
      // Two fingers down — start a pinch. Don't preventDefault on
      // touchstart (passive listeners are friendlier to scroll perf);
      // we'll preventDefault in touchmove instead.
      var t1 = e.touches[0], t2 = e.touches[1];
      state = {
        startDist: dist(t1, t2),
        startMid: mid(t1, t2),
        scale: 1,
        panX: 0,
        panY: 0
      };
      target.classList.add('is-pinching');
      // Block the host element's scroll/swipe handling during the pinch
      target.style.touchAction = 'none';
      onPinchStart();
    }, { passive: true });

    target.addEventListener('touchmove', function (e) {
      if (!state || !e.touches || e.touches.length < 2) return;
      // Block native pinch-zoom / page scroll while we're driving it
      if (e.cancelable) e.preventDefault();

      var t1 = e.touches[0], t2 = e.touches[1];
      var nowDist = dist(t1, t2);
      var nowMid = mid(t1, t2);

      // Scale = current distance / starting distance, clamped.
      // Dampen slightly so the gesture feels controlled, not loose.
      var rawScale = nowDist / state.startDist;
      var scale = Math.max(MIN_SCALE * 0.85, Math.min(maxScale, rawScale));

      // Pan = how far the midpoint of the two fingers has moved from
      // its start. Dampen so the image doesn't fully track the fingers.
      var panX = (nowMid.x - state.startMid.x) * 0.6;
      var panY = (nowMid.y - state.startMid.y) * 0.6;

      state.scale = scale;
      state.panX = panX;
      state.panY = panY;

      applyTransform(scale, panX, panY);
    }, { passive: false });

    function endHandler(e) {
      if (!state) return;
      // Only end the pinch when we're below 2 active touches
      if (e.touches && e.touches.length >= 2) return;
      // CSS transition picks up here — applyTransform('') triggers the
      // spring back to identity via the target's existing transition rule.
      reset();
    }

    target.addEventListener('touchend', endHandler);
    target.addEventListener('touchcancel', endHandler);
  }

  // Lightbox image
  var lightboxImg = document.querySelector('[data-lightbox-img]');
  var lightboxEl = document.querySelector('[data-lightbox]');
  if (lightboxImg && lightboxEl) {
    attachPinch(lightboxImg, {
      onPinchStart: function () { lightboxEl.classList.add('is-pinching'); },
      onPinchEnd: function () { lightboxEl.classList.remove('is-pinching'); }
    });
  }

  // Product-page mobile carousel — attach to each tile's image.
  // We only attach if the device actually has touch; on desktop the tiles
  // are click-only and the gesture is meaningless.
  if ('ontouchstart' in window) {
    var productMedia = document.querySelector('[data-product-media]');
    if (productMedia) {
      var imgs = productMedia.querySelectorAll('.product-grid-page__zoom img');
      Array.prototype.forEach.call(imgs, function (img) {
        attachPinch(img, { maxScale: 2.5 });
      });
    }
  }

})();


/* ═══════════════════════════════════════════
   HEADER SEARCH — inline reveal
   Clicking "Search" swaps the header's main row for a search input,
   same header height, no layout shift. Escape / Close / outside-click
   dismisses. Submits to Shopify's /search route natively.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var header     = document.querySelector('[data-site-header]');
  if (!header) return;

  var openBtn    = header.querySelector('[data-search-open]');
  var closeBtn   = header.querySelector('[data-search-close]');
  var searchRow  = header.querySelector('[data-header-search]');
  var searchInput = header.querySelector('[data-search-input]');
  if (!openBtn || !searchRow || !searchInput) return;

  var isOpen = false;
  var closeTimer = null;

  function clearCloseTimer() {
    if (!closeTimer) return;
    clearTimeout(closeTimer);
    closeTimer = null;
  }

  function finishClose() {
    if (isOpen) return;
    searchRow.hidden = true;
    searchInput.value = '';
    closeTimer = null;
  }

  function openSearch() {
    if (isOpen) return;
    clearCloseTimer();
    isOpen = true;
    searchRow.hidden = false;
    searchRow.offsetHeight;
    header.setAttribute('data-search-open', '');

    requestAnimationFrame(function () {
      setTimeout(function () {
        if (!isOpen) return;
        searchInput.focus({ preventScroll: true });
      }, 40);
    });
  }

  function closeSearch() {
    if (!isOpen) return;
    isOpen = false;
    clearCloseTimer();
    header.removeAttribute('data-search-open');

    closeTimer = setTimeout(finishClose, 260);
  }

  openBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  // Escape closes search when open
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeSearch();
      // Return focus to the open button for keyboard users
      openBtn.focus({ preventScroll: true });
    }
  });

  // Clicking outside the header while search is open dismisses it.
  // Important: the predictive search panel is a sibling of the header
  // (not inside it) so we must explicitly preserve clicks inside the
  // panel — otherwise clicking a result card closes the search before
  // the navigation can happen.
  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    if (e.target.closest('[data-site-header]')) return;
    if (e.target.closest('[data-predictive-search]')) return;
    closeSearch();
  });

  // If the form is submitted with an empty query, treat as a close instead
  var form = header.querySelector('.site-header__search-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!searchInput.value.trim()) {
        e.preventDefault();
        closeSearch();
      }
    });
  }

})();


/* ═══════════════════════════════════════════
   PREDICTIVE SEARCH — live results as the user types
   Hits Shopify's /search/suggest.json for fast product matches.
   Debounced; cancels in-flight requests when a new one starts.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var header        = document.querySelector('[data-site-header]');
  var input         = document.querySelector('[data-search-input]');
  var panel         = document.querySelector('[data-predictive-search]');
  if (!header || !input || !panel) return;

  var resultsEl     = panel.querySelector('[data-predictive-results]');
  var statusEl      = panel.querySelector('[data-predictive-status]');
  var allLink       = panel.querySelector('[data-predictive-all]');
  var allLabel      = panel.querySelector('[data-predictive-all-label]');
  // Bail if any required panel sub-element is missing — usually means
  // the merchant edited the header markup. Better to silently no-op
  // than throw and break the whole script.
  if (!resultsEl || !statusEl || !allLink || !allLabel) return;

  var MIN_QUERY_LEN = 1;
  var DEBOUNCE_MS   = 150;
  var MAX_RESULTS   = 6;

  var currentController = null;
  var debounceTimer = null;
  var activeIndex = -1;
  var results = [];  // array of { url, title, html } for keyboard nav

  /* ── Show / hide panel ── */
  function showPanel() {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
  }
  function hidePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    activeIndex = -1;
  }

  /* ── Escape HTML for safe insertion ── */
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  /* ── Render one result card ── */
  // Shopify's /search/suggest.json is inconsistent about featured_image:
  // sometimes it's a plain string URL, sometimes an object like
  // { url, src, alt, width, height }, and occasionally null/undefined.
  // Normalize all of these to a string URL (or '') so we never call
  // .indexOf on a non-string value and crash the whole panel render.
  function extractImageUrl(product) {
    var candidates = [
      product && product.featured_image,
      product && product.image
    ];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c) continue;
      if (typeof c === 'string') return c;
      if (typeof c === 'object') {
        if (typeof c.url === 'string') return c.url;
        if (typeof c.src === 'string') return c.src;
      }
    }
    return '';
  }

  // When Shopify's image object has its own alt (set on the image in the
  // product admin), prefer that for accessibility/SEO. Fall back to the
  // product title so the alt attribute is never empty.
  function extractImageAlt(product) {
    var candidates = [
      product && product.featured_image,
      product && product.image
    ];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c && typeof c === 'object' && typeof c.alt === 'string' && c.alt.trim()) {
        return c.alt.trim();
      }
    }
    return (product && product.title) || '';
  }

  function renderCard(product) {
    if (!product || typeof product !== 'object') return '';
    var image = extractImageUrl(product);
    var imageAlt = extractImageAlt(product);
    // Shopify returns protocol-relative URLs; ensure https
    if (image && image.indexOf('//') === 0) image = 'https:' + image;

    // /search/suggest.json returns price as a decimal STRING like "45.00"
    // (NOT cents). price_min / price_max give the variant range. We format
    // to match the rest of the site: '$45' style, no trailing zeros.
    function formatPriceString(p) {
      if (p == null || p === '') return '';
      var num = parseFloat(p);
      if (isNaN(num)) return esc(String(p));
      var amt = num.toFixed(2);
      if (amt.endsWith('.00')) amt = amt.slice(0, -3);
      return '$' + amt;
    }

    var priceHtml = '';
    var priceMin = product.price_min != null ? product.price_min : product.price;
    var priceMax = product.price_max != null ? product.price_max : product.price;
    if (priceMin != null && priceMax != null && parseFloat(priceMin) !== parseFloat(priceMax)) {
      priceHtml = 'From ' + formatPriceString(priceMin);
    } else if (priceMin != null) {
      priceHtml = formatPriceString(priceMin);
    }

    var soldOut = product.available === false;

    return (
      '<a class="predictive-search__card' + (soldOut ? ' is-sold-out' : '') + '" href="' + esc(product.url) + '">' +
        '<div class="predictive-search__card-media">' +
          (image
            ? '<img src="' + esc(image) + '" alt="' + esc(imageAlt) + '" loading="lazy">'
            : '<div class="predictive-search__card-placeholder"></div>'
          ) +
        '</div>' +
        '<div class="predictive-search__card-meta">' +
          '<span class="predictive-search__card-title">' + esc(product.title || '') + '</span>' +
          '<span class="predictive-search__card-price">' +
            (soldOut ? 'Sold out' : priceHtml) +
          '</span>' +
        '</div>' +
      '</a>'
    );
  }

  /* ── Render the results list ── */
  function renderResults(products, totalCount, query) {
    results = products.map(function (p) {
      return { url: p.url, title: p.title };
    });

    // Always offer a full-results link so users aren't trapped if they can't
    // find a match in the predictive panel.
    allLink.href = '/search?q=' + encodeURIComponent(query) + '&type=product';

    if (!products.length) {
      resultsEl.innerHTML = '';
      statusEl.textContent = 'No quick matches for "' + query + '".';
      statusEl.classList.add('is-empty');
      allLabel.textContent = 'Try a full search for "' + query + '"';
      allLink.hidden = false;
      return;
    }

    statusEl.textContent = '';
    statusEl.classList.remove('is-empty');

    // Render each card defensively — if one product is malformed in a way
    // we didn't anticipate, log it but keep the rest of the list working.
    var html = products.map(function (p) {
      try { return renderCard(p); }
      catch (err) {
        console.warn('[search] skipped malformed product:', err && err.message, p);
        return '';
      }
    }).filter(Boolean).join('');
    resultsEl.innerHTML = html;

    if (totalCount > products.length) {
      allLabel.textContent = 'View all ' + totalCount + ' results';
    } else {
      allLabel.textContent = 'See full results';
    }
    allLink.hidden = false;
  }

  /* ── Highlight active card (keyboard nav) ── */
  function updateActive() {
    var cards = resultsEl.querySelectorAll('.predictive-search__card');
    cards.forEach(function (c, i) {
      c.classList.toggle('is-active', i === activeIndex);
    });
    // Keep the active card in view if it scrolled off
    if (activeIndex >= 0 && cards[activeIndex]) {
      cards[activeIndex].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  /* ── Perform the search ── */
  function doSearch(query) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    statusEl.textContent = 'Searching…';
    statusEl.classList.remove('is-empty');

    // Use Shopify's route root if exposed (set in Dawn-style themes) to get
    // the correct locale prefix; fall back to '/' for plain English stores.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    // Build params with properly-encoded brackets — some Shopify
    // environments (and Safari edge-cases) don't accept bare [ ] in
    // query strings reliably. Use the default field set for the most
    // forgiving matching behaviour.
    var params = [
      'q=' + encodeURIComponent(query),
      encodeURIComponent('resources[type]') + '=product',
      encodeURIComponent('resources[limit]') + '=' + MAX_RESULTS,
      encodeURIComponent('resources[options][unavailable_products]') + '=last'
    ].join('&');

    // Build absolute URL off the page's origin — sidesteps any redirect
    // weirdness with Markets locale prefixing.
    var url = window.location.origin + root + 'search/suggest.json?' + params;

    fetch(url, {
      signal: currentController.signal,
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (body) {
            throw new Error('HTTP ' + r.status + ': ' + body.slice(0, 200));
          });
        }
        var ct = r.headers.get('content-type') || '';
        if (ct.indexOf('application/json') === -1) {
          throw new Error('Got ' + ct + ' instead of JSON (likely a redirect to the password or login page)');
        }
        return r.json();
      })
      .then(function (data) {
        var products = [];
        if (data && data.resources && data.resources.results) {
          var r = data.resources.results;
          if (Array.isArray(r.products)) {
            products = r.products;
          } else if (Array.isArray(r)) {
            products = r;
          }
        }
        renderResults(products, products.length, query);
        showPanel();
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        console.warn('[search] failed:', err && err.message, '\nURL:', url);

        // Surface the real error message so it can be diagnosed without
        // opening devtools.
        resultsEl.innerHTML = '';
        statusEl.textContent = 'Search error — ' + (err && err.message ? err.message.slice(0, 140) : 'unknown') + '. Press enter to use the full search page instead.';
        statusEl.classList.add('is-empty');
        allLink.href = root + 'search?q=' + encodeURIComponent(query) + '&type=product';
        allLabel.textContent = 'Search for "' + query + '"';
        allLink.hidden = false;
        showPanel();
      });
  }

  /* ── Input event: debounce, then search ── */
  input.addEventListener('input', function () {
    var q = input.value.trim();
    activeIndex = -1;

    if (debounceTimer) clearTimeout(debounceTimer);

    if (q.length < MIN_QUERY_LEN) {
      // Empty input: hide the panel
      hidePanel();
      return;
    }

    // Show the panel immediately with a loading state so there's no dead air
    statusEl.textContent = 'Searching…';
    statusEl.classList.remove('is-empty');
    showPanel();

    debounceTimer = setTimeout(function () { doSearch(q); }, DEBOUNCE_MS);
  });

  /* ── When the input is focused, show the panel if there's still a prior query ── */
  input.addEventListener('focus', function () {
    if (input.value.trim().length >= MIN_QUERY_LEN) {
      showPanel();
    }
  });

  /* ── Keyboard navigation ── */
  input.addEventListener('keydown', function (e) {
    var cards = resultsEl.querySelectorAll('.predictive-search__card');
    if (!cards.length) {
      // Enter with no predictive results: let the form submit normally
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIndex = Math.min(activeIndex + 1, cards.length - 1);
      updateActive();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIndex = Math.max(activeIndex - 1, -1);
      updateActive();
    } else if (e.key === 'Enter') {
      // If the user has arrow-selected a card, go to that card.
      // Otherwise, when predictive results exist, treat Enter as "open the
      // top result" — that's the live-search behaviour the panel implies,
      // and avoids the jarring full-page redirect to /search.
      if (activeIndex >= 0 && cards[activeIndex]) {
        e.preventDefault();
        window.location.href = cards[activeIndex].href;
      } else if (cards[0] && cards[0].href) {
        e.preventDefault();
        window.location.href = cards[0].href;
      }
      // If no cards at all, the earlier `if (!cards.length) return;` has
      // already let the form submit normally to /search.
    } else if (e.key === 'Escape') {
      hidePanel();
    }
  });

  /* ── Clicking outside closes panel ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-predictive-search]')) return;
    if (e.target.closest('[data-site-header]')) return;
    hidePanel();
  });

  /* ── When the main search UI closes, also hide the panel ──
     Observe the header's data-search-open attribute for removal. */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'data-search-open' && !header.hasAttribute('data-search-open')) {
        hidePanel();
        input.value = '';
        resultsEl.innerHTML = '';
      }
    });
  });
  observer.observe(header, { attributes: true });

})();


/* ═══════════════════════════════════════════
   SEARCH PAGE — smart back link
   If the user came from within the site, point "Back" at that page.
   Otherwise fall back to the default href (the catalog).
   ═══════════════════════════════════════════ */
(function () {
  'use strict';
  var link = document.querySelector('[data-search-back]');
  if (!link) return;
  var label = link.querySelector('[data-search-back-label]');

  var ref = document.referrer;
  if (!ref) return;

  try {
    var refUrl = new URL(ref);
    // Only reroute if referrer is same-origin and NOT a search results page
    // (otherwise we'd bounce between search pages)
    if (refUrl.origin === window.location.origin && !refUrl.pathname.startsWith('/search')) {
      link.href = ref;
      // Give the label a bit more context based on where they were
      if (label) {
        if (refUrl.pathname === '/' || refUrl.pathname === '') {
          label.textContent = 'Back to home';
        } else if (refUrl.pathname.indexOf('/collections/') === 0) {
          label.textContent = 'Back to collection';
        } else if (refUrl.pathname.indexOf('/products/') === 0) {
          label.textContent = 'Back to product';
        } else {
          label.textContent = 'Back';
        }
      }
    }
  } catch (e) { /* Invalid referrer URL; keep default */ }
})();


/* ════════════════════════════════════════════
   FLOATING CURRENCY PICKER
   ════════════════════════════════════════════ */
(function () {
  'use strict';

  var picker = document.querySelector('[data-currency-picker]');
  if (!picker) return;

  var toggle = picker.querySelector('[data-currency-picker-toggle]');
  var panel = picker.querySelector('[data-currency-picker-panel]');
  var closeBtn = picker.querySelector('[data-currency-picker-close]');
  if (!toggle || !panel) return;

  function openPanel() {
    panel.hidden = false;
    picker.setAttribute('data-open', '');
    toggle.setAttribute('aria-expanded', 'true');
  }
  function closePanel() {
    panel.hidden = true;
    picker.removeAttribute('data-open');
    toggle.setAttribute('aria-expanded', 'false');
  }
  function isOpen() { return !panel.hidden; }

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    if (isOpen()) closePanel(); else openPanel();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closePanel();
    });
  }

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!isOpen()) return;
    if (e.target.closest('[data-currency-picker]')) return;
    closePanel();
  });

  // Close on escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closePanel();
  });
})();


/* ════════════════════════════════════════════
   LOOKBOOK HOMEPAGE — staggered fade-in reveal
   IntersectionObserver toggles .is-in on items.
   ════════════════════════════════════════════ */
(function () {
  if (!('IntersectionObserver' in window)) {
    // No observer support — just show everything.
    document.querySelectorAll('[data-lookbook-item]').forEach(function (el) {
      el.classList.add('is-in');
    });
    return;
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var items = (root || document).querySelectorAll('[data-lookbook-home] [data-lookbook-item]');
    if (!items.length) return;

    if (reduceMotion) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    // Stagger within each section, not globally.
    var sectionIndex = new WeakMap();

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var section = el.closest('[data-lookbook-home]');
        var idx = sectionIndex.get(section) || 0;
        // Item-by-item reveal: 160ms apart so each one lands distinctly.
        // Capped so very long sections don't drag the last items in too late.
        var delay = Math.min(idx * 160, 1280);
        el.style.transitionDelay = delay + 'ms';
        // Cascade the same delay onto the inner reveal layers (clip-path mask,
        // image scale, caption fade) so each item's internal animation also
        // starts at its slot rather than all firing at once.
        var reveal = el.querySelector(':scope > .lookbook-home__reveal, :scope > a > .lookbook-home__reveal, :scope > figure > .lookbook-home__reveal');
        if (reveal) reveal.style.transitionDelay = delay + 'ms';
        var revealImg = reveal && reveal.querySelector('img');
        if (revealImg) revealImg.style.transitionDelay = delay + 'ms';
        var caption = el.querySelector(':scope > .lookbook-home__caption');
        if (caption) caption.style.transitionDelay = (delay + 350) + 'ms';
        var overlayText = el.querySelector('.lookbook-home__overlay-text');
        if (overlayText) overlayText.style.transitionDelay = (delay + 450) + 'ms';

        el.classList.add('is-in');
        sectionIndex.set(section, idx + 1);
        observer.unobserve(el);
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12
    });

    items.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init when the Shopify theme editor swaps a section in.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-lookbook-home]')) {
      init(e.target);
    }
  });
})();
